module.exports = __webpack_public_path__ + "src/assets/img/ohlopkov.708a8b97.png";